export enum ProjectItemOrigin {
    MAIN                = 1,
    LINKED              = 2,
    INHERITED_SUBTASK   = 3,
}